import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Loading, Breadcrumbs } from "../../components/shared";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { clearDataFromIndexDB, getDataFromIndexDB } from "../../utils/dataStore";
const PasswordVerify = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  //const [user] = useState(null);
  const { authenticateUser, loading: authLoading } = useAuth("verify-email");
  const navigate = useNavigate(); // Initialize navigate for navigation

  useEffect(() => {

    // Declare the async function inside useEffect
    const verifyEmail = async () => {
      let authTokenTemp = await getDataFromIndexDB('authTokenTemp');

      await clearDataFromIndexDB('authTokenTemp');

      if (authTokenTemp && authTokenTemp !== "") {
        // If authTokenTemp exists, authenticate the user with it (no email verification required)
        try {
          await authenticateUser(authTokenTemp);
          setLoading(false); // Set loading to false
        } catch (err) {
          console.error("Error authenticating user with authTokenTemp:", err);
          setError("Authentication failed. Please try again.");
          navigate("/auth/login"); // Navigate to the Login page
        }
      } else {
        setError("Invalid or expired sign-in link.");
        setLoading(false);
      }
    };

    verifyEmail(); // Call the async function inside useEffect

  }, [navigate]); // Ensure dependencies are correctly set


  if (authLoading || loading) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
  if (error) return <p>பிழை: {error}</p>;


  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | பதிவு சரிபார்ப்பு</title>
        <link rel="canonical" href="/auth/signup/verify" />
      </Helmet>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <div>
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
      </div >

      <Footer />
    </>
  );
};

export default PasswordVerify;
